import React from 'react'

const Jva_maxChar = () => {
    return (
        <div className='container'>
            <article>
  <h1>Java Program To Find Maximum And Minimum Occurring Character</h1>

  <div>
  <p><strong>Input: </strong>Enter the string: Apple</p>
  <p><strong>Output: </strong>Maximum Occurrence : p</p>
  <p>Minimum Occurrence: A</p>
  </div>
  <p> </p>
  <h2>Program 1: Find the Minimum and Maximum Occurring Character</h2>
  <p>In this program, we will see how to calculate the minimum and maximum occurring characters in a string when the
    string is user-defined. Here, we will ask the user to initialize the array and then we will find out the minimum and
    maximum occurring character</p>
  <h3>Algorithm:</h3>
  <ol>
    <li>
      <p>Start</p>
    </li>
    <li>
      <p>Declare a string</p>
    </li>
    <li>
      <p>Ask the user to initialize it.</p>
    </li>
    <li>
      <p>Declare an array to store the frequency of the elements.</p>
    </li>
    <li>
      <p>Declare variables for minimum and maximum occurring characters and assign them to 0.</p>
    </li>
    <li>
      <p>Convert the string to a character array.</p>
    </li>
    <li>
      <p>Use two for loops for the same.</p>
    </li>
    <li>
      <p>Use the first for loop to iterate through each character in the string.</p>
    </li>
    <li>
      <p>Select the characters and initialize their corresponding frequency in the frequency array to 1.</p>
    </li>
    <li>
      <p>Use the second for loop to compare the selected character with the rest of the characters present in the
        string.</p>
      <div class="text-center" id="adview1">
        <div data-ad="InContent"></div>
      </div>
    </li>
    <li>
      <p>Again use two for loops to iterate over the frequency array.</p>
    </li>
    <li>
      <p>Use the min and max variable to store the count of minimum and maximum occurring characters in the string.</p>
    </li>
    <li>
      <p>Iterate over the loop and compare the count of each character stored in freq with min and max.</p>
    </li>
    <li>
      <p>If the count stored in freq is less than the value of min, then store that count in the min and corresponding
        character in minChar.</p>
    </li>
    <li>
      <p>If the count stored in freq is more than the value of max, then store that count in max and corresponding
        character in maxChar.</p>
    </li>
    <li>
      <p>Now, the minChar will store the minimum occurring character and maxChar will store the maximum occurring
        character.</p>
    </li>
    <li>
      <p>Print the minimum and maximum occurring characters.</p>
    </li>
    <li>
      <p>Stop</p>  <br />
    </li>  <br />
  </ol>  <br />
  <p>The below example illustrates the implementation of the above algorithm.</p>  <br />
  <pre class=" containers"><code class=" language-java"><span class="comment">//Java Program to find the maximum and minimum occurring character in a string</span>  <br />
<span class="keywords">import</span> <span class="namespace">java<span class="plain">.</span>util<span class="plain">.</span></span><span class="operator">*</span><span class="plain">;</span>  <br />
<span class="keywords">public</span> <span class="keywords">class</span> <span class="library">Main</span>    <br />
<span class="plain">&#123;</span>  <br />
   <span class="keywords">public</span> <span class="keywords">static</span> <span class="keywords">void</span> <span class="function">main</span><span class="plain">(</span><span class="library">String</span><span class="plain">[</span><span class="plain">]</span> args<span class="plain">)</span>   <br />
   <span class="plain">&#123;</span>      <br />
       <span class="comment">//Take input from the user </span>  <br />
        <span class="library">Scanner</span> sc<span class="operator">=</span><span class="keywords">new</span> <span class="library">Scanner</span><span class="plain">(</span><span class="library">System</span><span class="plain">.</span>in<span class="plain">)</span><span class="plain">;</span>  <br />
        <span class="library">System</span><span class="plain">.</span>out<span class="plain">.</span><span class="function">println</span><span class="plain">(</span><span class="string">"Enter the string: "</span><span class="plain">)</span><span class="plain">;</span>  <br />
        <span class="library">String</span> str<span class="operator">=</span>sc<span class="plain">.</span><span class="function">nextLine</span><span class="plain">(</span><span class="plain">)</span><span class="plain">;</span>  <br />
      <span class="keywords">int</span><span class="plain">[</span><span class="plain">]</span> freq <span class="operator">=</span> <span class="keywords">new</span> <span class="keywords">int</span><span class="plain">[</span>str<span class="plain">.</span><span class="function">length</span><span class="plain">(</span><span class="plain">)</span><span class="plain">]</span><span class="plain">;</span>      <br />
      <span class="keywords">char</span> minChar <span class="operator">=</span> str<span class="plain">.</span><span class="function">charAt</span><span class="plain">(</span><span class="number">0</span><span class="plain">)</span><span class="plain">,</span> maxChar <span class="operator">=</span> str<span class="plain">.</span><span class="function">charAt</span><span class="plain">(</span><span class="number">0</span><span class="plain">)</span><span class="plain">;</span>    <br />  
      <span class="keywords">int</span> i<span class="plain">,</span> j<span class="plain">,</span> min<span class="plain">,</span> max<span class="plain">;</span>              <br />
      <span class="keywords">char</span> string<span class="plain">[</span><span class="plain">]</span> <span class="operator">=</span> str<span class="plain">.</span><span class="function">toCharArray</span><span class="plain">(</span><span class="plain">)</span><span class="plain">;</span>      <br />
      <span class="keywords">for</span><span class="plain">(</span>i <span class="operator">=</span> <span class="number">0</span><span class="plain">;</span> i <span class="operator">&lt;</span> string<span class="plain">.</span>length<span class="plain">;</span> i<span class="operator">++</span><span class="plain">)</span>   <br />
	  <span class="plain">&#123;</span>      <br />
          freq<span class="plain">[</span>i<span class="plain">]</span> <span class="operator">=</span> <span class="number">1</span><span class="plain">;</span>      <br />
          <span class="keywords">for</span><span class="plain">(</span>j <span class="operator">=</span> i<span class="operator">+</span><span class="number">1</span><span class="plain">;</span> j <span class="operator">&lt;</span> string<span class="plain">.</span>length<span class="plain">;</span> j<span class="operator">++</span><span class="plain">)</span>   <br />
		  <span class="plain">&#123;</span>      <br />
              <span class="keywords">if</span><span class="plain">(</span>string<span class="plain">[</span>i<span class="plain">]</span> <span class="operator">==</span> string<span class="plain">[</span>j<span class="plain">]</span> <span class="operator">&amp;&amp;</span> string<span class="plain">[</span>i<span class="plain">]</span> <span class="operator">!=</span> <span class="string">' '</span> <span class="operator">&amp;&amp;</span> string<span class="plain">[</span>i<span class="plain">]</span> <span class="operator">!=</span> <span class="string">'0'</span><span class="plain">)</span> <br /> 
			  <span class="plain">&#123;</span>      <br />
                  freq<span class="plain">[</span>i<span class="plain">]</span><span class="operator">++</span><span class="plain">;</span>      <br />
                        <br />
                  string<span class="plain">[</span>j<span class="plain">]</span> <span class="operator">=</span> <span class="string">'0'</span><span class="plain">;</span>      <br />
              <span class="plain">&#125;</span>      <br />
          <span class="plain">&#125;</span>      <br />
      <span class="plain">&#125;</span>      <br />
      min <span class="operator">=</span> max <span class="operator">=</span> freq<span class="plain">[</span><span class="number">0</span><span class="plain">]</span><span class="plain">;</span>      <br />
      <span class="keywords">for</span><span class="plain">(</span>i <span class="operator">=</span> <span class="number">0</span><span class="plain">;</span> i <span class="operator">&lt;</span>freq<span class="plain">.</span>length<span class="plain">;</span> i<span class="operator">++</span><span class="plain">)</span>   <br />
	  <span class="plain">&#123;</span>      <br />
          <span class="keywords">if</span><span class="plain">(</span>min <span class="operator">&gt;</span> freq<span class="plain">[</span>i<span class="plain">]</span> <span class="operator">&amp;&amp;</span> freq<span class="plain">[</span>i<span class="plain">]</span> <span class="operator">!=</span> <span class="string">'0'</span><span class="plain">)</span>   <br />
		  <span class="plain">&#123;</span>      <br />
              min <span class="operator">=</span> freq<span class="plain">[</span>i<span class="plain">]</span><span class="plain">;</span>      <br />
              minChar <span class="operator">=</span> string<span class="plain">[</span>i<span class="plain">]</span><span class="plain">;</span>      <br />
          <span class="plain">&#125;</span>      <br />
          <span class="keywords">if</span><span class="plain">(</span>max <span class="operator">&lt;</span> freq<span class="plain">[</span>i<span class="plain">]</span><span class="plain">)</span>   <br />
		  <span class="plain">&#123;</span>      <br />
              max <span class="operator">=</span> freq<span class="plain">[</span>i<span class="plain">]</span><span class="plain">;</span>      <br />
              maxChar <span class="operator">=</span> string<span class="plain">[</span>i<span class="plain">]</span><span class="plain">;</span>      <br />
          <span class="plain">&#125;</span>      <br />
      <span class="plain">&#125;</span>               <br />
      <span class="library">System</span><span class="plain">.</span>out<span class="plain">.</span><span class="function">println</span><span class="plain">(</span><span class="string">"Minimum occurring character: "</span> <span class="operator">+</span> minChar<span class="plain">)</span><span class="plain">;</span>      <br />
      <span class="library">System</span><span class="plain">.</span>out<span class="plain">.</span><span class="function">println</span><span class="plain">(</span><span class="string">"Maximum occurring character: "</span> <span class="operator">+</span> maxChar<span class="plain">)</span><span class="plain">;</span>      <br />
  <span class="plain">&#125;</span>    <br />
<span class="plain">&#125;</span></code></pre>  <br />
  <p class="output"><br/>  <br />
    Enter the string: Find the minimum and maximum occurring character<br/>
    Minimum occurring character: F<br/>
    Maximum occurring character: m</p>
  <p> </p>
  <p> </p>
 
</article>
        </div>
    )
}

export default Jva_maxChar
